<template>
    <div class="home" v-loading="loading">
        <!-- 首屏 -->
        <section class="hero">
            <div class="hero-media">
                <img class="hero-img" :src="getImagePath(heroImage)" :alt="heroAlt"/>
                <div class="hero-scrim" aria-hidden="true"></div>
                <div class="hero-inner">
                    <div class="hero-copy">
                        <h1 class="hero-title">
                            <span class="hero-title-main">{{ $t('home.heroTitle') }}</span>
                            <span class="hero-title-accent">{{ $t('home.heroTitleAccent') }}</span>
                        </h1>
                        <p class="hero-sub">{{ $t('home.heroSubtitle') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 最新资讯 -->
        <section class="section section-news">
            <h2 class="section-title">{{ $t('home.latestNews') }}</h2>
            <div class="news-grid">
                <article class="news-card" v-for="(news,i) in newsList" :key="i">
                    <router-link
                        class="text-decoration"
                        :to="{ name: 'newsdetails', params: { id: news.Id }}"
                    >
                        <div class="news-card-img" v-lazy:background-image="imgserver + news.Img2"></div>
                    </router-link>
                    <h3 class="news-card-title">{{ news.Title }}</h3>
                    <p class="news-card-excerpt">{{ news.Content }}</p>
                    <router-link
                        class="text-decoration news-card-more"
                        :to="{ name: 'newsdetails', params: { id: news.Id }}"
                    >
                        <img :src="getImagePath('sanjiao.png')" alt=""/>
                        <span>{{ $t('home.details') }}</span>
                    </router-link>
                </article>
            </div>
        </section>

        <!-- 经典案例 -->
        <section class="section section-cases">
            <h2 class="section-title">{{ $t('home.successfulCases') }}</h2>
            <ul class="case-grid">
                <li
                    v-for="(item,index) in caseList"
                    :key="index"
                    v-lazy:background-image="imgserver + item.Img"
                >
                    <router-link
                        class="text-decoration case-link"
                        :to="{ name: 'casedetails', params: { id: item.Id }}"
                    >
                        <div class="case-item-hover">
                            <p class="hover-title">{{ item.Title }}</p>
                            <div class="bottom"></div>
                            <div class="more">
                                <span>{{ $t('home.details') }}</span>
                            </div>
                        </div>
                    </router-link>
                </li>
            </ul>
        </section>
    </div>
</template>


<script>
export default {
    name: "HelloWorld",
    data() {
        return {
            loading: true,
            caseList: [],
            newsList: [],
            // 过渡期主视觉：home_top.jpg 的标题和 logo 烧在像素里，会和这里的真实文字叠字，不能用。
            // 干净底图到位后，img-zh / img-en 各放一份，再把这里改成 'home_top_clean.jpg'。
            heroImage: 'home_anli.jpg'
        };
    },
    computed: {
        heroAlt() {
            return `${this.$t('home.heroTitle')} ${this.$t('home.heroTitleAccent')}`;
        }
    },
    mounted() {
        this.$http
            .all([
                this.$http.get("Cases/GetCasesAll"),
                this.$http.get(`News?type=1&num=3`)
            ])
            .then(
                this.$http.spread((responseCases, responseNews) => {
                    this.caseList = responseCases.data.data;
                    this.newsList = responseNews.data.data;
                    this.loading = false;
                }),
                error => {
                    window.console.log(error);
                    this.loading = false;
                }
            );
    }
};
</script>

<style lang="scss" scoped>
.home {
    width: 100%;
}

.text-decoration {
    text-decoration: none;
}

.section {
    padding: 56px 0 64px;
}

.section-news {
    background-color: #fff;
}

.section-cases {
    background-color: #f4f7fa;
}

.section-title {
    width: 1240px;
    max-width: 100%;
    margin: 0 auto 28px;
    padding: 0 20px;
    box-sizing: border-box;
    font-size: 32px;
    font-weight: 400;
    color: #14679f;
    text-align: center;
}

/* ============ 首屏 ============ */
.hero {
    width: 100%;
}

.hero-media {
    position: relative;
    width: 100%;
    // 高度交给 CSS，不再读 window.innerHeight（原实现只在 data() 里算一次，永不更新）
    height: 56.25vw;                // 16:9，作为不支持 min() 时的兜底
    height: min(56.25vw, 64vh);     // 同时不超过视口高 64%，保证下一节在首屏露头
    max-height: 720px;              // 超大屏封顶
    overflow: hidden;
    background-color: #14679f;      // 图片未就绪时的品牌底色
}

.hero-img {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.hero-scrim {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        90deg,
        rgba(6, 30, 48, 0.7) 0%,
        rgba(6, 30, 48, 0.45) 38%,
        rgba(6, 30, 48, 0.08) 68%,
        rgba(6, 30, 48, 0) 100%
    );
}

.hero-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // 用 grid 居中，不用 flex + align-items:center：后者会让百分比宽的子项塌陷成 0
    display: grid;
    place-items: center;
}

.hero-copy {
    width: 1240px;
    max-width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
}

.hero-title {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0 0.34em;
    margin: 0;
    font-size: clamp(30px, 4.4vw, 62px);
    line-height: 1.14;
    font-weight: 700;
    color: #fff;
}

.hero-title-accent {
    color: #ff5a4e;
}

.hero-sub {
    margin: clamp(10px, 1.1vw, 20px) 0 0;
    font-size: clamp(15px, 1.35vw, 24px);
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);
}

/* ============ 最新资讯 ============ */
.news-grid {
    width: 1240px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: grid;
    // minmax(0,·) 必需：卡片里有文本，长英文串会撑出 min-content 下限把网格顶爆
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 40px;
}

.news-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.news-card-img {
    width: 100%;
    height: 220px;
    background-color: #e8eef4;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.news-card-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 16px 0 8px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4;
    color: #15669e;
}

.news-card-excerpt {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0 0 12px;
    font-size: 14px;
    line-height: 1.7;
    color: #666;
    word-break: break-word;
}

.news-card-more {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: auto;   // 三张卡文字长短不一时「详情」仍然贴底对齐
    align-self: flex-start;
    font-size: 14px;
    color: #e13834;

    img {
        width: 12px;
        height: 12px;
    }
}

/* ============ 经典案例 ============ */
.case-grid {
    width: 1240px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    list-style: none;
    display: grid;
    // auto-fit：空轨道会被折叠，列数随数据量走，网格本身没有固定高
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;

    > li {
        position: relative;
        min-width: 0;
        height: 300px;
        overflow: hidden;
        background-color: #dfe7ee;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        cursor: pointer;

        // 线上接口只返回 1 条：auto-fit 折叠后单条轨道是整宽 1200，
        // 会被拉成一条畸形横幅。限宽居中 → 读起来是「精选案例」而不是「坏了」
        &:only-child {
            width: 100%;
            max-width: 640px;
            justify-self: center;
        }
    }
}

.case-link {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.case-item-hover {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
    opacity: 0;
    overflow: hidden;
    background-color: rgba(225, 56, 52, 0.72);
    transition: opacity 0.4s ease-in-out;

    .hover-title {
        width: 100%;
        margin: 0;
        color: #fff;
        font-size: 18px;
        font-weight: 400;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .bottom {
        width: 60px;
        margin: 12px auto 0;
        border-bottom: 1px solid #fff;
    }

    .more {
        width: 90px;
        margin: 24px auto 0;
        padding: 5px;
        box-sizing: border-box;
        border: 2px solid #fff;
        text-align: center;

        span {
            color: #fff;
            font-size: 18px;
        }
    }
}

.case-grid > li:hover .case-item-hover {
    opacity: 1;
}

/* 触屏没有 :hover，红色蒙版永远不出现，标题和「详情」就完全不可达。
   改成常显的底部渐变字幕条，整块磁贴仍可点 */
@media (max-width: 768px), (hover: none), (pointer: coarse) {
    .case-item-hover {
        top: auto;
        bottom: 0;
        height: auto;
        padding: 22px 10px 8px;
        opacity: 1;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.78) 0%, rgba(0, 0, 0, 0.42) 62%, rgba(0, 0, 0, 0) 100%);

        .hover-title {
            font-size: 14px;
            text-align: left;
        }

        .bottom,
        .more {
            display: none;
        }
    }
}

/* ============ 两级断点（与其它页面、App.vue 一致） ============ */
@media (max-width: 1280px) {
    .section {
        padding: 44px 0 52px;
    }

    .news-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 28px;
    }

    .case-grid > li {
        height: 260px;
    }
}

@media (max-width: 768px) {
    .section {
        padding: 30px 0 36px;
    }

    .section-title {
        margin-bottom: 18px;
        padding: 0 12px;
        font-size: 22px;
    }

    // 首屏改成「图上 / 文下」：375 宽的 16:9 图只有 211px 高，压不下两行标题
    .hero-media {
        height: auto;
        max-height: none;
    }

    .hero-img {
        position: static;
        width: 100%;
        height: auto;
    }

    .hero-scrim {
        display: none;
    }

    .hero-inner {
        position: static;
        display: block;
        width: auto;
        height: auto;
    }

    .hero-copy {
        padding: 18px 12px 26px;
    }

    .hero-title {
        font-size: 28px;
    }

    .hero-title-accent {
        color: #ff6a5e;     // 蓝底上提亮一档，#e13834 在 #14679f 上对比度不足
    }

    .hero-sub {
        margin-top: 8px;
        font-size: 15px;
    }

    .news-grid {
        grid-template-columns: minmax(0, 1fr);
        gap: 24px;
        padding: 0 12px;
    }

    .news-card-img {
        height: 200px;
    }

    .case-grid {
        padding: 0 12px;

        > li {
            height: 210px;

            &:only-child {
                max-width: none;
            }
        }
    }
}
</style>
